import { lazy } from 'react';
var ADV00001 = lazy(function () { return import('view/Project/ADV/ADV00001'); });
var ADV00002 = lazy(function () { return import('view/Project/ADV/ADV00002'); });
var ADV00003 = lazy(function () { return import('view/Project/ADV/ADV00003'); });
var ADV_ROUTES = [
    { path: '/ADV00/ADV00001', component: ADV00001 },
    { path: '/ADV00/ADV00002', component: ADV00002 },
    { path: '/ADV00/ADV00003', component: ADV00003 },
];
export default ADV_ROUTES;
